import React, { useState } from 'react';

const WriteBox = ({ onTextChange }) => {
  const [text, setText] = useState('');
  const words = text.trim().split(/\s+/).filter(Boolean).length;

  const handleChange = (e) => {
    const newText = e.target.value;
    setText(newText);
    onTextChange(newText);  // Call the parent's callback function with the new text
  };

  return (
    <div className="p-4 px- mt-8 border-y border-gray-300 rounded-sm">
      <textarea
        className="w-full h-64 p-2 resize-none border border-gray-300 rounded-sm focus:outline-none focus:ring focus:border-blue-300"
        placeholder="Start writing..."
        value={text}
        onChange={handleChange}
      />
      <div className="mt-2 flex justify-between">
        <p>{words} words</p>
        {/* <button
          className="px-4 py-2 bg-blue-500 text-white rounded-sm hover:bg-blue-600 focus:outline-none focus:ring focus:bg-blue-600"
          onClick={() => {
            // Handle saving the text
            console.log('Saving text:', text);
          }}
        >
          Submit
        </button> */}
      </div>
    </div>
  );
};

export default WriteBox;
